'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = require('react');
var div = React.DOM.div;
var focusManager = require('../helpers/focusManager');
var scopeTab = require('../helpers/scopeTab');

var noOp = function noOp() {};

var defaultProps = {
  onAfterClose: noOp,
  style: {
    overlay: {},
    content: {}
  },
  overlayClassName: 'ReactModal__Overlay',
  className: 'ReactModal__Content'
};

var ModalPortal = module.exports = React.createClass({
  displayName: 'ModalPortal',
  shouldClose: null,

  getDefaultProps: function getDefaultProps() {
    return defaultProps;
  },

  getInitialState: function getInitialState() {
    return {
      afterOpen: false,
      beforeClose: false
    };
  },

  componentDidMount: function componentDidMount() {
    // Focus needs to be set when mounting and already open
    if (this.props.isOpen) {
      this.setFocusAfterRender(true);
      this.open();
    }
  },

  componentWillUnmount: function componentWillUnmount() {
    clearTimeout(this.closeTimer);
  },

  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
    // Focus only needs to be set once when the modal is being opened
    if (!this.props.isOpen && newProps.isOpen) {
      this.setFocusAfterRender(true);
      this.open();
    } else if (this.props.isOpen && !newProps.isOpen) {
      this.close();
    }
  },

  componentDidUpdate: function componentDidUpdate() {
    if (this.focusAfterRender) {
      this.focusContent();
      this.setFocusAfterRender(false);
    }
  },

  setFocusAfterRender: function setFocusAfterRender(focus) {
    this.focusAfterRender = focus;
  },

  open: function open() {
    if (this.state.afterOpen && this.state.beforeClose) {
      clearTimeout(this.closeTimer);
      this.setState({ beforeClose: false });
    } else {
      focusManager.setupScopedFocus(this.node);
      focusManager.markForFocusLater();
      this.setState({ isOpen: true }, function () {
        this.setState({ afterOpen: true });

        if (this.props.isOpen && this.props.onAfterOpen) {
          this.props.onAfterOpen();
        }
      }.bind(this));
    }
  },

  close: function close() {
    if (!this.ownerHandlesClose()) return;
    if (this.props.closeTimeoutMS > 0) this.closeWithTimeout();else this.closeWithoutTimeout();
  },

  focusContent: function focusContent() {
    // Don't steal focus from inner elements
    if (!this.contentHasFocus()) {
      this.refs.content.focus();
    }
  },

  closeWithTimeout: function closeWithTimeout() {
    this.setState({ beforeClose: true }, function () {
      this.closeTimer = setTimeout(this.closeWithoutTimeout, this.props.closeTimeoutMS);
    }.bind(this));
  },

  closeWithoutTimeout: function closeWithoutTimeout() {
    this.setState({
      beforeClose: false,
      isOpen: false,
      afterOpen: false
    }, this.afterClose);
  },

  afterClose: function afterClose() {
    focusManager.returnFocus();
    focusManager.teardownScopedFocus();
    this.props.onAfterClose();
  },

  handleKeyDown: function handleKeyDown(event) {
    if (event.keyCode == 9 /*tab*/) scopeTab(this.refs.content, event);
    if (event.keyCode == 27 /*esc*/) {
        event.preventDefault();
        this.requestClose(event);
      }
  },

  handleOverlayMouseDown: function handleOverlayMouseDown(event) {
    if (this.shouldClose === null) {
      this.shouldClose = true;
    }
  },

  handleOverlayMouseUp: function handleOverlayMouseUp(event) {
    if (this.shouldClose && this.props.shouldCloseOnOverlayClick) {
      if (this.ownerHandlesClose()) this.requestClose(event);else this.focusContent();
    }
    this.shouldClose = null;
  },

  handleContentMouseDown: function handleContentMouseDown(event) {
    this.shouldClose = false;
  },

  handleContentMouseUp: function handleContentMouseUp(event) {
    this.shouldClose = false;
  },

  requestClose: function requestClose(event) {
    if (this.ownerHandlesClose()) this.props.onRequestClose(event);
  },

  ownerHandlesClose: function ownerHandlesClose() {
    return this.props.onRequestClose;
  },

  shouldBeClosed: function shouldBeClosed() {
    return !this.props.isOpen && !this.state.beforeClose;
  },

  contentHasFocus: function contentHasFocus() {
    return document.activeElement === this.refs.content || this.refs.content.contains(document.activeElement);
  },

  buildClassName: function buildClassName(baseClass) {
    var className = baseClass + " ";
    if (this.state.afterOpen) className += baseClass + '--after-open';
    if (this.state.beforeClose) className += baseClass + '--before-close';
    return className;
  },

  getPropInlineStyle: function getPropInlineStyle(useDefaultStyle, styleName) {
    var defaultStyles = useDefaultStyle ? this.props.defaultStyles[styleName] : {};
    var propsStyles = this.props.style[styleName] || {};
    return _extends({}, defaultStyles, propsStyles);
  },

  isPropEqualToDefault: function isPropEqualToDefault(propName) {
    return this.props[propName] === defaultProps[propName];
  },

  render: function render() {
    var contentStyles = this.getPropInlineStyle(this.isPropEqualToDefault("className"), "content");
    var overlayStyles = this.getPropInlineStyle(this.isPropEqualToDefault("overlayClassName"), "overlay");

    return this.shouldBeClosed() ? div() : div({
      ref: "overlay",
      className: this.buildClassName(this.props.overlayClassName),
      style: overlayStyles,
      onMouseDown: this.handleOverlayMouseDown,
      onMouseUp: this.handleOverlayMouseUp
    }, div({
      ref: "content",
      style: contentStyles,
      className: this.buildClassName(this.props.className),
      tabIndex: "-1",
      onKeyDown: this.handleKeyDown,
      onMouseDown: this.handleContentMouseDown,
      onMouseUp: this.handleContentMouseUp,
      role: "dialog"
    }, this.props.children));
  }
});


//////////////////
// WEBPACK FOOTER
// ../~/react-modal-onfido/lib/components/ModalPortal.js
// module id = 440
// module chunks = 1